import { Award } from "lucide-react";
import {Link} from 'react-router-dom'
import CRMIntroImage from '../../../Assets/crm-intro.jpg';
import { Helmet } from 'react-helmet';

const CRM = () => {

  const services = [
    {
      title: "Salesforce CRM Services",
      subtitle: "Enterprise-Grade Customization & Support",
      icon: "Cloud",
      colorBg: "#f97316",
      gradient: "linear-gradient(135deg, #f97316, #ef4444)",
      textColor: "#111827",
      dotColor: "#f97316",
      features: [
        "Sales Cloud, Service Cloud, Marketing Cloud Implementation",
        "Custom App Development with Apex & Lightning",
        "ERP & eCommerce Integrations",
        "Ongoing Support & Lightning Migration"
      ]
    },
    {
      title: "Microsoft Dynamics 365 CRM",
      subtitle: "Unified Business Intelligence",
      icon: "Layout",
      colorBg: "#2563eb",
      gradient: "linear-gradient(135deg, #2563eb, #06b6d4)",
      textColor: "#111827",
      dotColor: "#2563eb",
      features: [
        "Sales Hub, Customer Service & Field Service Setup",
        "Power Platform Integration (Power Apps, Power Automate)",
        "Industry-Specific Customizations",
        "Legacy System Migration & Managed Services"
      ]
    },
    {
      title: "Zoho CRM Services",
      subtitle: "Cost-Effective & Scalable CRM",
      icon: "Shield",
      colorBg: "#0d9488",
      gradient: "linear-gradient(135deg, #0d9488, #059669)",
      textColor: "#111827",
      dotColor: "#0d9488",
      features: [
        "Sales Automation & Pipeline Tracking",
        "Zia AI Assistant & Blueprint Workflows",
        "Zoho Flow & Marketplace Integrations",
        "Zoho One Ecosystem Integration"
      ]
    },
    {
      title: "HubSpot CRM Services",
      subtitle: "Inbound Marketing & Sales Automation",
      icon: "Rocket",
      colorBg: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899, #f43f5e)",
      textColor: "#111827",
      dotColor: "#ec4899",
      features: [
        "Sales, Marketing, Service & Operations Hub",
        "Lead Nurturing & Email Sequences",
        "Forms, Chatbots & Landing Pages",
        "Data Migration & Performance Optimization"
      ]
    },
    {
      title: "SAP Customer Experience (C/4HANA)",
      subtitle: "Enterprise-Grade CRM for Global Operations",
      icon: "Globe",
      colorBg: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6, #6366f1)",
      textColor: "#111827",
      dotColor: "#8b5cf6",
      features: [
        "SAP Sales, Service & Marketing Cloud",
        "Integration with SAP ERP & S/4HANA",
        "GDPR-Compliant Data Management",
        "User Training & Ongoing Support"
      ]
    },
    {
      title: "Odoo CRM Services",
      subtitle: "Modular CRM for Operational Simplicity",
      icon: "Box",
      colorBg: "#16a34a",
      gradient: "linear-gradient(135deg, #16a34a, #059669)",
      textColor: "#111827",
      dotColor: "#16a34a",
      features: [
        "Lead Tracking & Sales Pipeline Automation",
        "Tight Integration with Accounting & eCommerce",
        "Custom App Development & Dashboards",
        "Mobile-Friendly & Multilingual Support"
      ]
    }
  ];

    const StatItem = ({ number, label }) => (
        <div className="text-center p-6 transform hover:scale-105 transition-transform duration-300">
        <div
            style={{
            background: "linear-gradient(to right, #2563eb, #9333ea)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            }}
            className="text-4xl md:text-5xl font-bold mb-2"
        >
            {number}
        </div>
        <div style={{ color: "#4b5563" }} className="font-medium">
            {label}
        </div>
        </div>
    );

      const features = [
    {
      title: "Platform Expertise",
      description: "Certified professionals with deep expertise across Salesforce, Microsoft Dynamics, HubSpot, and other leading CRM platforms.",
      color: "#4F46E5"
    },
    {
      title: "Business-Driven Approach",
      description: "We align CRM solutions with your business goals, ensuring maximum ROI and user adoption.",
      color: "#059669"
    },
    {
      title: "End-to-End Delivery",
      description: "From strategy and implementation to training and support, we handle every aspect of your CRM journey.",
      color: "#DC2626"
    },
    {
      title: "Proven Methodology",
      description: "Our structured implementation framework ensures on-time, on-budget delivery with minimal business disruption.",
      color: "#EA580C"
    }
  ];



  return (
    <>
      <Helmet>
        <title>PT KCS | Customer Relationship Management (CRM) Solutions Indonesia</title>
        <meta 
          name="description" 
          content="PT KCS offers comprehensive CRM solutions in Indonesia to improve customer engagement and sales processes. We implement Salesforce, Microsoft Dynamics 365, Zoho, HubSpot, and Odoo CRM." 
        />
        <meta 
          name="keywords" 
          content="PT KCS, PT KCS Indonesia, CRM solutions Jakarta, Salesforce CRM services, Microsoft Dynamics 365 implementation Indonesia, Zoho CRM consulting, HubSpot sales automation, SAP Customer Experience, Odoo CRM implementation, CRM consulting and support Indonesia" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

        <section className="pt-12 pb-20 px-4 sm:px-6 lg:px-8" style={{ background: "linear-gradient(90deg, #3daee2ff 0%, #284079ff 100%)" }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div
              className="inline-flex items-center px-4 py-2 rounded-full border backdrop-blur-sm"
              style={{
                backgroundColor: "rgba(255,255,255,0.1)",
                borderColor: "rgba(255,255,255,0.2)",
              }}
            >
              <Award
                style={{
                  width: "36px",
                  height: "36px",
                  color: "#FBBF24",
                  marginRight: "8px",
                }}
              />
              <span
                className="text-sm font-medium"
                style={{ color: "rgba(255,255,255,0.9)" }}
              >
                CRM Excellence Partner
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold leading-tight" style={{color:'#ffffff'}}>
              Transform Your <br/>
              <span
                style={{
                  color:'#ffffff',
                }}
                className="text-2xl md:text-3xl font-bold inline-block pb-3"
              >
                {" "}
                Business with World-Class
              </span> <br/>
               CRM <span
                style={{
                  color:'#ffffff',
                }}
                className="text-2xl md:text-3xl font-bold inline-block pb-3"
              >
                {" "}
                Solutions
              </span>
            </h1>

            <p className="text-xl leading-relaxed" style={{color:'#ffffff'}}>
              At PTKCS, we deliver comprehensive CRM services that unify sales, marketing, customer service, and data analytics into a cohesive growth strategy. From implementation to long-term support, we transform the way you engage with customers.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact">
                <button
                style={{
                  background: "linear-gradient(to right, #2568f8ff, #6c60daff)",
                  color: "white",
                }}
                className="px-8 py-4 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-200"
              >
                Get Started Today
              </button>
                </Link>
            </div>
          </div>

        <div className="relative">
            <div className="relative">
              <img
              src={CRMIntroImage}
              alt="CRM"
              className="rounded-lg border w-full shadow-2xl"
              style={{ borderColor: "rgba(255,255,255,0.1)" }}
            />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 style={{ color: "#111827" }} className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
            Our Comprehensive CRM Services
          </h2>
          <p style={{ color: "#4b5563" }} className="text-xl max-w-3xl mx-auto leading-relaxed">
            We specialize in implementing and optimizing leading CRM platforms to maximize your business potential
          </p>
          
          {/* Decorative element */}
          <div className="mt-8 flex justify-center">
            <div 
              style={{ background: "linear-gradient(90deg, #3b82f6, #8b5cf6)" }} 
              className="w-32 h-1 rounded-full"
            ></div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:border-transparent overflow-hidden"
              style={{ borderColor: "#e5e7eb" }}
            >
              <div className="flex items-center space-x-5 mb-7">
                <div 
                  style={{ background: service.gradient }}
                  className="w-16 h-16 rounded-2xl flex items-center justify-center text-white shadow-lg transform transition-transform duration-300 group-hover:scale-110"
                >
                  {service.icon === "Cloud" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M3 15v4c0 1.1.9 2 2 2h14a2 2 0 002-2v-4M3 10l18 0M3 10l6-6m-6 6l6 6" />
                    </svg>
                  )}
                  {service.icon === "Layout" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                    </svg>
                  )}
                  {service.icon === "Shield" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  )}
                  {service.icon === "Rocket" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  )}
                  {service.icon === "Globe" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                  {service.icon === "Box" && (
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="32" 
                      height="32" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                  )}
                </div>
                
                <div>
                  <h3 style={{ color: service.textColor }} className="text-2xl font-bold">
                    {service.title}
                  </h3>
                  <p style={{ color: "#4b5563" }} className="text-lg">
                    {service.subtitle}
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                {service.features.map((feature, featureIndex) => (
                  <div 
                    key={featureIndex}
                    className="flex items-start space-x-4"
                  >
                    <div 
                      style={{ backgroundColor: service.dotColor }}
                      className="flex-shrink-0 w-3 h-3 mt-2 rounded-full"
                    ></div>
                    <span style={{ color: "#374151" }} className="leading-relaxed">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              {/* Subtle gradient overlay on hover */}
              <div 
                style={{ background: service.gradient }}
                className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 rounded-2xl pointer-events-none"
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
    
    <section className="py-24 bg-gradient-to-br from-slate-50 via-white to-indigo-50" style={{
    background: "linear-gradient(to bottom right, #f8fafc, #ffffff, #eef2ff)",}}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 leading-tight">
            Why Choose <span style={{ 
              background: "linear-gradient(90deg, #4F46E5, #7C3AED)", 
              WebkitBackgroundClip: "text", 
              WebkitTextFillColor: "transparent", 
              backgroundClip: "text" 
            }} className="text-3xl md:text-4xl font-bold mb-4">PTKCS</span> as Your <br/>CRM Implementation Partner?
          </h2>

          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
            At PTKCS, we bring platform expertise, business acumen, and delivery excellence to every CRM engagement. 
          </p>
          
          {/* Elegant divider */}
          <div className="flex justify-center mt-12">
            <div style={{ background: "linear-gradient(90deg, transparent, #a5b4fc, transparent)" }} className="w-32 h-0.5"></div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl transition-all duration-700 hover:-translate-y-4 hover:border-transparent"
            >
              {/* Card content */}
              <div className="relative z-10">
                {/* Icon container with floating effect */}
                <div 
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-8 mx-auto transition-all duration-500 group-hover:scale-110 group-hover:rotate-6"
                  style={{ 
                    background: feature.color,
                    boxShadow: `0 20px 25px -5px ${feature.color}15, 0 8px 10px -6px ${feature.color}20`
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                    strokeWidth={2.5}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="font-bold text-2xl text-gray-900 mb-4 group-hover:text-gray-800 transition-colors duration-300">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm group-hover:text-gray-700 transition-colors duration-300">
                    {feature.description}
                  </p>
                </div>
              </div>

              {/* Subtle gradient overlay */}
              <div 
                className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500 rounded-3xl"
                style={{ 
                  background: `linear-gradient(135deg, ${feature.color}20, transparent)` 
                }}
              ></div>

              {/* Corner accent */}
              <div 
                className="absolute top-6 right-6 w-2 h-2 rounded-full opacity-30"
                style={{ backgroundColor: feature.color }}
              ></div>
              <div 
                className="absolute bottom-6 left-6 w-3 h-3 rounded-full opacity-20"
                style={{ backgroundColor: feature.color }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section style={{ backgroundColor: "#eef3faff" }} className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 style={{ color: "#111827" }} className="text-3xl md:text-4xl font-bold mb-4">
            Driving Business Growth Through CRM Excellence
          </h2>
          <p style={{ color: "#4b5563" }} className="text-xl max-w-3xl mx-auto">
            Our proven expertise delivers measurable results for businesses of all sizes
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <StatItem number="98%" label="Client Satisfaction Rate" />
          <StatItem number="250+" label="Successful Implementations" />
          <StatItem number="24/7" label="Dedicated Support" />
        </div>
      </div>
    </section>
    </>
  );
};

export default CRM;